import React, { useContext, useEffect } from 'react';
import { courseLinksDataType } from 'views/Questions/Question.types';
import useClickStreamEvent from 'utils/clickstream/useClickStreamEvent';
import { appAuthContext } from 'context/AuthContext';
import styles from './CourseLinksData.module.css';

type CourseLinksDataProps = {
  courseLinksData: courseLinksDataType;
};
const CourseLinksData = ({ courseLinksData }: CourseLinksDataProps) => {
  const { sendEvent } = useClickStreamEvent();
  const { user } = useContext(appAuthContext);

  const sendClickEvent = async () => {
    await sendEvent({
      eventType: 'click',
      eventInfo: `otvety_preparing`,
    });
  };

  useEffect(() => {
    sendEvent({
      eventType: 'display',
      eventInfo: `otvety_preparing`,
    });
  }, []);

  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>
        {user && user?.data?.attributes?.type === 'teacher' ? (
          <>План подготовки к уроку</>
        ) : (
          <>Поможет разобраться с&nbsp;этим вопросом</>
        )}
      </p>
      <div className={styles.links}>
        {courseLinksData &&
          courseLinksData.length > 0 &&
          courseLinksData.map((i) => (
            <a
              className={styles.item}
              href={`${i.link}?utm_source=otvety&utm_medium=click_link&utm_campaign=otvety_preparing`}
              target="_blank"
              key={i.title}
              rel="noopener"
              onClick={sendClickEvent}
            >
              {i.title}
            </a>
          ))}
      </div>
    </div>
  );
};

export default CourseLinksData;
